import React, { useCallback, useContext } from "react";

import { Auth } from "api/makeApiRequest";
import { DashboardContext } from "components/PageDashboard/PageDashboard";
import ModalMarkPaid from "components/PageDashboard/ModalMarkPaid";
import { ApiRequest } from "api/makeApiRequest/ApiRequest";

type Props<T> = {
	markingPaid: T | undefined;
	setMarkingPaid: React.Dispatch<React.SetStateAction<T | undefined>>;
	dashboardContextKey: string;
	summary: (item: T, uid: string) => React.ReactNode;
	itemDescription: string;
	markPaid: (data: T, auth: Auth) => ApiRequest<{}>;
};

function MarkingPaid<T extends { id: string }>({
	markingPaid,
	setMarkingPaid,
	dashboardContextKey,
	summary,
	itemDescription,
	markPaid
}: Props<T>) {
	const handleCancelMarkingPaid = useCallback(async () => {
		setMarkingPaid(undefined);
	}, [setMarkingPaid]);

	const [, setDashboardContextState] = useContext(DashboardContext);

	const handleMarkedPaidOK = useCallback(async () => {
		setMarkingPaid(undefined);
		setDashboardContextState(oldState => ({
			...oldState,
			[dashboardContextKey]: new Date().getTime()
		}));
	}, [setMarkingPaid, setDashboardContextState, dashboardContextKey]);

	return (
		<ModalMarkPaid
			item={markingPaid}
			itemDescription={itemDescription}
			markPaid={markPaid}
			isOpen={!!markingPaid}
			onCancel={handleCancelMarkingPaid}
			onOK={handleMarkedPaidOK}
			summary={summary}
		/>
	);
}

export default MarkingPaid;
